import React from 'react';
import _ from 'lodash';
import { Snackbar, Alert } from '@mui/material';

export const SnackbarAlert = ({ open, message, severity, onClose, vertical = 'bottom', horizontal = 'right', autoHideDuration = 4000 }) => (
  <Snackbar anchorOrigin={{ vertical, horizontal }} open={open} autoHideDuration={autoHideDuration} onClose={onClose}>
    <Alert onClose={onClose} severity={severity}>{message}</Alert>
  </Snackbar>
);
